import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { AccountContext } from '../../Components/Context/AccountContext';
import { FilterContext } from '../../Components/Context/FilterContext';
import ProductSlider from '../../Components/Filter/Components/ProductSlider/ProductSlider';
import { FilterResult } from '../../Components/Filter/Types';

const AdditionalProductsSliderIntegration: React.FunctionComponent = () => {
    const productSliderContainer = document.querySelector('#js-product-slider-container') as HTMLElement;

    const { isFilterActive, result, isLoading } = useContext(FilterContext);
    const { isLoggedIn } = useContext(AccountContext);

    const [products, setProducts] = useState<FilterResult[]>([]);

    useEffect(() => {
        setProducts(
            result.filter((product) => {
                if (product.articleNumber === articleNumberFromDom) {
                    return false;
                }

                if (isFilterActive) {
                    return (
                        product.customerSpecificData.passesIngredientsCheck &&
                        product.customerSpecificData.passesSkinCheck
                    );
                } else if (isLoggedIn) {
                    return product.customerSpecificData.passesIngredientsCheck;
                }

                return true;
            }),
        );
    }, [result, isLoggedIn]);

    if (!productSliderContainer) {
        return null;
    }
    const articleNumberFromDom = productSliderContainer.dataset.articleNumber;

    return ReactDOM.createPortal(
        <ProductSlider
            reloadOnUpdate={true}
            headline={isFilterActive ? 'Weitere Produkte passend zu Ihrem Hautbild' : 'Weitere Produkte'}
            products={products}
            loading={isLoading}
        />,
        productSliderContainer,
    );
};

export default AdditionalProductsSliderIntegration;
